export default {
  'commissionmanagement.commissionmanagement': 'إدارة النقاط',
  'commissionmanagement.accountsnotify': 'الرجاء إدارة حساباتك المصرفية من',
  'commissionmanagement.accountsnotify1': 'الرابط.',
  'commissionmanagement.accountmanagement': 'إدارة حسابات البنوك',
  'commissionmanagement.description': 'الوصف',
  'commissionmanagement.bankaccount': 'رقم الحساب',
  'commissionmanagement.save': 'حفظ',
  'commissionmanagement.addrequest': 'نقطة إلى المال',
  'commissionmanagement.withdrawamount': 'سحب النقاط',
  'commissionmanagement.index': 'فهرس',
  'commissionmanagement.requestdate': 'تاريخ الطلب',
  'commissionmanagement.requeststatus': 'حالة الطلب',
  'commissionmanagement.withdrawtype': 'نوع السحب',
  'commissionmanagement.requestadd': 'تمت إضافة طلب السحب بنجاح',
  'commissionmanagement.tryagain': 'يرجى المحاولة مرة أخرى',
  'commissionmanagement.deleterequest': 'حذف طلب السحب',
  'commissionmanagement.deleteerror': 'لا يمكن حذف هذا الطلب',
  'commissionmanagement.disapprove': 'رفض',
  'commissionmanagement.approve': 'موافقة',
  'commissionmanagement.pending': 'في انتظار',
  'commissionmanagement.notpaid': 'غير مدفوع',
  'commissionmanagement.paid': 'مدفوع',
  'commissionmanagement.showdetail': 'عرض التفاصيل',
  'commissionmanagement.incomedetail': 'تفاصيل الدخل',
  'commissionmanagement.withdrawreport': 'تقرير المعاملات',
  'commissionmanagement.transferpoints': 'نقل النقاط',
  'commissionmanagement.buycard': 'شراء بطاقات الشحن',
  'commissionmanagement.paybill': 'دفع الفاتورة',
  'commissionmanagement.spendpoints': 'إنفاق النقاط',
  'commissionmanagement.transfermoney': 'تحويل الأموال',
  'commissionmanagement.lottery': 'اليانصيب',
  'commissionmanagement.earnpoints': 'كسب النقاط',
  'commissionmanagement.redandantrequest':
    'هناك طلب معلق. يرجى عدم إرسال طلب آخر.',
  'commissionmanagement.exitfee': 'رسوم الخروج',
  'commissionmanagement.exitTax': 'ضرائب الخروج',
  'commissionmanagement.requestreport': 'تقرير طلبات السحب',
  'commissionmanagement.phrase': 'رقم المستند',
  'commissionmanagement.documentdescription': 'وصف المستند',
  'commissionmanagement.transferamount': 'النقاط القابلة للتحويل',
  'commissionmanagement.pointamount': 'مبلغ النقاط',
  'commissionmanagement.secondpassword': 'كلمة مرور ثانوية',
  'commissionmanagement.transfererror':
    'المبلغ المطلوب من النقاط أكبر من المبلغ المتبقي من النقاط',
  'commissionmanagement.transfernotify':
    'عزيزي المستخدم لنقل النقاط، يرجى استخدام ال',
  'commissionmanagement.transfernotify1': 'رابط.',
  'commissionmanagement.addsecondpassword': 'إضافة كلمة مرور ثانوية',
  'commissionmanagement.resecondpassword': 'كلمة المرور الثانية',
  'commissionmanagement.wagenotify1': 'هل توافق على خصم',
  'commissionmanagement.wagenotify2': 'نقطة للأجر؟',
  'commissionmanagement.errorsecondpassword':
    'كلمة المرور الثانوية غير مسجلة. يرجى إضافة كلمة المرور الثانوية أولاً',
  'commissionmanagement.wrongsecondpassword': 'كلمة المرور الثانوية خاطئة',
  'commissionmanagement.successtransfer': 'تم نقل النقاط بنجاح',
  'commissionmanagement.notenoughpoint':
    'النقاط المطلوبة غير مسموح بها بسبب نقاطك المعلقة',
  'commissionmanagement.sameprofiles': 'المرسل هو نفس المستلم',
  'commissionmanagement.deleteconfirm': 'هل أنت متأكد من حذف طلب سحب النقاط؟',
  'commissionmanagement.deletesucess': 'تم حذف طلب السحب بنجاح',
  'commissionmanagement.customer': 'العملاء',
  'commissionmanagement.employee': 'الموظفين',
  'commissionmanagement.request': 'الطلبات',
  'commissionmanagement.income': 'دخلك',
  'commissionmanagement.wallet': 'ترقية محفظتك',
  'commissionmanagement.customerregion': 'المنطقة القائمة على العملاء',
  'commissionmanagement.totalpoint': 'إجمالي النقاط',
  'commissionmanagement.requestprice': 'المبلغ المطلوب',
  'commissionmanagement.sendsms': 'إرسال رسالة نصية',
  'commissionmanagement.requestpoint': 'النقاط المطلوبة',
  'commissionmanagement.wallettransaction': 'آخر معاملات المحفظة',
  'commissionmanagement.recenttransactions': 'المعاملات الأخيرة',
  'commissionmanagement.pointtransactions': 'المعاملات النقطية',
  'commissionmanagement.transitional': 'مرحلية',
  'commissionmanagement.exitfeepayment': 'دفع رسوم الخروج',
  'commissionmanagement.moneydescription':
    'يمكنك تحويل نقاطك إلى نقود وإيداعها في حسابك المصرفي.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'بهذه الطريقة، يمكنك نقل نقاطك إلى مستخدمي Tripsi.',
  'commissionmanagement.transferpointdescriptionTripord':
    'بهذه الطريقة، يمكنك نقل نقاطك إلى مستخدمي Tripord.',
  'commissionmanagement.getpointdescription':
    'هناك عدة طرق لزيادة نقاطك والحصول على رحلات مجانية.',
  'commissionmanagement.spendpointdescription':
    'يمكنك استخدام نقاطك في مختلف الأقسام والحصول على خدمات مجانية.',
  'commissionmanagement.buycarddescription':
    'من خلال النقاط، يمكنك الحصول على بطاقة Hamrah Aval، Irancell و Taliya مجانًا.',
  'commissionmanagement.buyCard': 'شراء بطاقة',
  'commissionmanagement.exitfeedescription': 'بنقاطك، يمكنك دفع ضرائب الخروج.',
  'commissionmanagement.buypoint': 'شراء نقطة',
  'commissionmanagement.safeway': 'الطريقة الأمنة',
  'commissionmanagement.spendanywhere': 'إنفاق في أي مكان',
  'commissionmanagement.deposit': 'إيداع إلى الحساب',
  'commissionmanagement.easyway': 'أسهل الطرق',
  'commissionmanagement.fastway': 'أسرع الطرق',
  'commissionmanagement.entersecondpassword': 'أدخل كلمة المرور الثانوية',
  'commissionmanagement.usepoint': 'صديقي العزيز، استخدم النقاط بشكل جيد',
  'commissionmanagement.textTransferpoints':
    'يمكنك نقل نقاطك إلى حساب مستخدم آخر من خلال النموذج أدناه.',
  'commissionmanagement.textRequest':
    'يمكنك تحويل نقاطك إلى نقود من خلال النموذج أدناه.',
  'commissionmanagement.textDetails':
    'يمكنك عرض أو تحرير تفاصيل المستخدم المطلوب من خلال النموذج التالي.',
  'commissionmanagement.InternalServer': 'خطأ في الخادم الداخلي',
};
